import { required, max, email } from '@vee-validate/rules'
import { defineRule, configure } from 'vee-validate'

import { showInfo } from '@/services/toastService'

// Define validation rules
defineRule('required', required)
defineRule('max', max)
defineRule('email', email)

// Configure VeeValidate
configure({
  generateMessage: (ctx) => {
    const messages: Record<string, string> = {
      required: `${ctx.field} is required`,
      max: `${ctx.field} must be at most ${
        Array.isArray(ctx.rule?.params) ? ctx.rule.params[0] : ctx.rule?.params
      } characters`,
      email: `${ctx.field} must be a valid email address`,
    }
    return messages[ctx.rule?.name as string] || `${ctx.field} is invalid`
  },
})

// Validation schemas for different field types
export const nameValidationRules = 'required|max:255'
export const descriptionValidationRules = 'max:2048'
export const optionalNameValidationRules = 'max:255'
export const emailValidationRules = 'required|email'

/**
 * Truncate text to a maximum length to ensure it fits validation rules
 * @param text The text to truncate
 * @param maxLength Maximum allowed length (default: 255)
 * @param fieldName Optional field name for toast notification (e.g., "Tour name", "Track name")
 * @returns Truncated text
 */
export function truncateToMaxLength(
  text: string | undefined,
  maxLength: number = 255,
  fieldName?: string,
): string | undefined {
  if (!text) return text
  if (text.length <= maxLength) return text

  const truncated = text.substring(0, maxLength)

  // Show info toast if field name is provided
  if (fieldName) {
    showInfo(`${fieldName} was truncated to ${maxLength} characters`)
  }

  return truncated
}
